export default {
  en: {
    preview_title2: 'Good suited or Bad suited?',
    article2_examples: 'Examples: ',
    article2_good_suited: '<span class="keyword-red">Good suited</span>: ',
    article2_bad_suited: '<span class="keyword-purple">Bad suited</span>: ',
    article2_title: `
           Good suited or Bad suited? 
            `,
    article2_header: '<span class="keyword-red">Good suited</span> or <span class="keyword-purple">Bad suited</span>?',
    article2_text: `
            When we already know how to determine the type of starting hand and its 
            belonging to one of the suite categories, we move on to the subcategories, 
            namely <span class="keyword-red">Good suited</span> and <span class="keyword-purple">Bad suited</span>.
        `,
    article2_text1: `
            These two categories can only be found in hands that are already double or 
            <span class="keyword-blue">Single suited</span>. Mono and rainbow hands have no subcategories.
            Distribution by hand strength, with the strongest categories on top.
        `,
    article2_text2: `
            Distribution by hand strength, with the strongest categories on top.
        `,
    article2_text3: `
            So what is <span class="keyword-red">Good suited</span>? This is the position of the suits in the hand that
            will give us the maximum potential in the postflop or preflop play.
        `,
    article2_text4: `
            The rest are — <span class="keyword-purple">Bad suited</span>.
        `,
    article2_header1: `
            <span class="keyword-red">Double suited</span> 
        `,
    article2_text5: `
            Let's start with  <span class="keyword-red">Double suited</span> hands.
        `,
    article2_text6: `
            The rule is very simple. If we can qualify for the two high flushes our hand allows, 
            then it's <span class="keyword-red">Good suited</span>. 
            If not, it's <span class="keyword-purple">Bad suited</span>.
        `,
    article2_text7: `
            Let's take a starting unpaired hand as an example.
            <img src="AtCARD" class="textCard" alt="card" />
            <img src="QtCARD" class="textCard" alt="card" />
            <img src="JtCARD" class="textCard" alt="card" />
            <img src="3tCARD" class="textCard" alt="card" />
        `,
    article2_cards_description: `
            <span class="keyword-red">Good suited</span>. There is an opportunity to improve to a flush by
            both ace and queen (two high cards in our hand).
        `,
    article2_cards_description1: `
            <span class="keyword-purple">Bad suited</span>. There is still an opportunity to improve to 
            a flush on the ace, but the second flush on which we can count only on the jack.
        `,
    article2_cards_description2: `
            <span class="keyword-red">Good suited</span>.
        `,
    article2_cards_description3: `
            <span class="keyword-purple">Bad suited</span>.
        `,
    article2_text8: `
            If we have a pair hand or a two pair  <span class="keyword-red">Double suited</span> hand, 
            they will all be good suited <span class="keyword-red">Good suited</span>. 
            <span class="keyword-purple">Bad suited</span> are impossible.
        `,
    article2_header2: `
            <span class="keyword-blue">Single suited</span> 
        `,
    article2_text9: `
            Moving on to the unpaired <span class="keyword-blue">Single suited</span> hands.
        `,
    article2_text10: `
            Continue with <span class="keyword-blue">Single suited</span> hands
            <img src="AtCARD" class="textCard" alt="card" />
            <img src="KtCARD" class="textCard" alt="card" />
            <img src="QtCARD" class="textCard" alt="card" />
            <img src="2tCARD" class="textCard" alt="card" />.
        `,
    article2_text11: `
            What do these hands have in common? The presence of a suit on a high card in hand and 
            another of the same suit. We maximize the chance of improving to the best flush for our 
            hand and don't take our outs off ourselves if we have a flush draw. This is a
            <span class="keyword-red">Good suited</span> hand.
            <img src="AtCARD" class="textCard" alt="card" />
            <img src="KtCARD" class="textCard" alt="card" />
            <img src="QtCARD" class="textCard" alt="card" />
            <img src="2tCARD" class="textCard" alt="card" />.
            <span class="keyword-blue">Single suited</span> + <span class="keyword-red">Good suited</span>.
        `,
    article2_text12: `
            While some examples are <span class="keyword-red">Good suited</span> hands (we have the potential for maximum flush for our hand),
            it spoils the presence of a third card of the same suit. We take away equity from ourselves.
            These hands are -
            <img src="AtCARD" class="textCard" alt="card" />
            <img src="KtCARD" class="textCard" alt="card" />
            <img src="QtCARD" class="textCard" alt="card" />
            <img src="2tCARD" class="textCard" alt="card" />.
            <span class="keyword-blue">Single suited</span> + <span class="keyword-purple">Bad suited</span>.
        `,
    article2_text13: `
            In other examples, the flush potential is not the highest possible for a given hand.
        `,
    article2_text14: `
            The outcome — <span class="keyword-red">Good suited</span> is the presence of a suit on a 
            high card and another card of the same suit.
            <span class="keyword-purple">Bad suited</span> — everything else.
        `,
    article2_text15: `
            A few examples to consolidate information:
        `,
    article2_description4: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-red">Good suited</span> (suit on a high card + another card of this suit).  
        `,
    article2_description5: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-purple">Bad suited</span> (suit on a high card + two more cards of this suit).
        `,
    article2_description6: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-red">Good suited</span> (suit on a high card + another card of this suit).
        `,
    article2_description7: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-purple">Bad suited</span> (suit not on high card).
        `,
    article2_description8: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-red">Good suited</span> (suit on a high card + another card of this suit).
        `,
    article2_description9: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-purple">Bad suited</span> (suit not on high card). 
        `,
    article2_text16: `
            Now paired <span class="keyword-blue">Single suited</span> hands
        `,
    article2_text17: `
            If there are two cards in hand including high card it is <span class="keyword-red">good suited</span>,
             if three cards including high card or two cards excluding high card are <span class="keyword-purple">bad suited</span>.
        `,
    article2_text17_2: 'Example:',
    article2_text18: `
            If there are two cards in hand including high card it is <span class="keyword-blue">Single suited</span>, if three cards including 
            high card or two cards excluding high card are <span class="keyword-red">Good suited</span>.
        `,
    article2_text19: `
            <span class="keyword-red">Double suited</span> paired hands are always <span class="keyword-red">Good suited</span>. <span class="keyword-purple">Bad suited</span> are impossible.
        `,
  },
  ru: {
    preview_title2: 'Good suited или Bad suited?',
    article2_examples: 'Примеры: ',
    article2_good_suited: '<span class="keyword-red">Good suited</span>: ',
    article2_bad_suited: '<span class="keyword-purple">Bad suited</span>: ',
    article2_title: `
            Good suited или Bad suited? 
            `,
    article2_header: '<span class="keyword-red">Good suited</span> or <span class="keyword-purple">Bad suited</span>?',
    article2_text: `
            Когда мы уже умеем определять тип стартовой руки и ее принадлежность к 
            одной из сьют категории, перейдем к подкатегориям, а именно good 
            suited и <span class="keyword-purple">Bad suited</span>.
        `,
    article2_text1: `
            Эти две категории могут быть только у тех рук, которые уже попали в 
            тип double или <span class="keyword-blue">Single suited</span>. У mono и rainbow рук подкатегорий нет.
        `,
    article2_text2: `
            <span class="img-description">
            Распределение по силе рук, где сверху самые сильные категории.
            </span>
        `,
    article2_text3: `
            Итак, что такое <span class="keyword-red">Good suited</span>? Это расположение мастей в руке которое даст 
            нам максимальный потенциал при розыгрыше постфлоп или выставлении на префлопе.
        `,
    article2_text4: `
            Все остальные — <span class="keyword-purple">Bad suited</span>.
        `,
    article2_header1: `
            <span class="keyword-red">Double suited</span> 
        `,
    article2_text5: `
            Начнем с <span class="keyword-red">Double suited</span> рук.
        `,
    article2_text6: `
            Правило очень простое. Если мы можем претендовать на два старших флэша, 
            которые позволяет наша рука, то это <span class="keyword-red">Good suited</span>. Если нет, то это <span class="keyword-purple">Bad suited</span>.
        `,
    article2_text7: `
            Для примера возьмем стартовую непарную руку
            <img src="AtCARD" class="textCard" alt="card" />
            <img src="QtCARD" class="textCard" alt="card" />
            <img src="JtCARD" class="textCard" alt="card" />
            <img src="3tCARD" class="textCard" alt="card" />.
        `,
    article2_cards_description: `
            <span class="keyword-red">Good suited</span>. Есть возможность усилиться до флэша как по тузу, так и по даме 
            (две старшие карты в нашей руке).
        `,
    article2_cards_description1: `
            <span class="keyword-purple">Bad suited</span>. По-прежнему есть возможность усилиться до флэша по тузу, но второй флэш 
            на который можем рассчитывать будет только по валету.
        `,
    article2_cards_description2: `
            <span class="keyword-red">Good suited</span>.
        `,
    article2_cards_description3: `
            <span class="keyword-purple">Bad suited</span>.
        `,
    article2_text8: `
            Если у нас рука с парой или двухпарная <span class="keyword-red">Double suited</span> рука, то они все будут <span class="keyword-red">Good suited</span>. 
            <span class="keyword-purple">Bad suited</span> невозможны.
        `,
    article2_header2: `
            <span class="keyword-blue">Single suited</span> 
        `,
    article2_text9: `
            Перейдем к непарным <span class="keyword-blue">Single suited</span> рукам.
        `,
    article2_text10: `
            Продолжим с <span class="keyword-blue">Single suited</span> руки
            <img src="AtCARD" class="textCard" alt="card" />
            <img src="KtCARD" class="textCard" alt="card" />
            <img src="QtCARD" class="textCard" alt="card" />
            <img src="2tCARD" class="textCard" alt="card" />.
        `,
    article2_text11: `
            Что общего между этими руками? Наличие масти по хай карте в руке и еще одной
            этой же масти. Мы максимизируем шанс усилиться до лучшего флэша для нашей 
            руки и не отнимаем сами у себя ауты, если будем иметь флэш дро. Это и есть
            <span class="keyword-red">Good suited</span> рука. Это и есть <span class="keyword-red">Good suited</span> рука.
            <img src="AtCARD" class="textCard" alt="card" />
            <img src="KtCARD" class="textCard" alt="card" />
            <img src="QtCARD" class="textCard" alt="card" />
            <img src="2tCARD" class="textCard" alt="card" />.
            <span class="keyword-blue">Single suited</span> + <span class="keyword-red">Good suited</span>.
        `,
    article2_text12: `
            Хоть в некоторых примерах и соблюдается правило <span class="keyword-red">Good suited</span> руки (у нас есть 
            потенциал на максимальный флэш для нашей руки), но все это портит наличие 
            третьей карты такой же масти. Сами у себя отнимаем эквити.
            Эти руки —
            <img src="AtCARD" class="textCard" alt="card" />
            <img src="KtCARD" class="textCard" alt="card" />
            <img src="QtCARD" class="textCard" alt="card" />
            <img src="2tCARD" class="textCard" alt="card" />.
            <span class="keyword-blue">Single suited</span> + <span class="keyword-purple">Bad suited</span>.
        `,
    article2_text13: `
            В других примерах потенциал на флэш не максимально возможный для данной руки. 
        `,
    article2_text14: `
            Итог — <span class="keyword-red">Good suited</span> это наличие масти по хай карте и еще одна карта этой же масти. 
            <span class="keyword-purple">Bad suited</span> — все остальное.
        `,
    article2_text15: `
            Несколько примеров для закрепления информации:
        `,
    article2_description4: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-red">Good suited</span> (масть по хай карте + еще одна карта этой масти).  
        `,
    article2_description5: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-purple">Bad suited</span> (масть по хай карте + еще две карты этой масти).
        `,
    article2_description6: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-red">Good suited</span> (масть по хай карте + еще одна карта этой масти).
        `,
    article2_description7: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-purple">Bad suited</span> (масть не по хай карте).
        `,
    article2_description8: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-red">Good suited</span> (масть по хай карте + еще одна карты этой масти).
        `,
    article2_description9: `
            <span class="keyword-blue">Single suited</span> + <span class="keyword-purple">Bad suited</span> (масть не по хайкарте). 
        `,
    article2_text16: `
            Теперь парные <span class="keyword-blue">Single suited</span> руки
        `,
    article2_text17: `
            Если в руке две карты включая хай карту это
             <span class="keyword-red">good suited</span>, если три карты включая хай карту или две
              исключая хай карту - <span class="keyword-purple">bad suited</span>.
        `,
    article2_text17_2: 'Пример:',
    article2_text18: `
            Если в парной руке есть потенциал усилиться до флэша от туза или короля,
            то <span class="keyword-red">Good suited</span> будут являться те руки, у которых от двух до трех мастей 
            по хай карте в руке.
        `,
    article2_text19: `
            <span class="keyword-red">Double suited</span> парные руки всегда <span class="keyword-red">good suited</span>. <span class="keyword-purple">Bad suited</span> невозможны.
        `,
  },
};
